export const getIconUrl = ({
  origin,
  appKey,
  appIconLink
}) => {
  if (origin === 'token') return null;
  return appIconLink.expand({
    appKey
  });
};
export const getFallbackIconUrl = (origin, icon) => origin === 'token' ? null : icon;
export const getIconType = origin => origin === 'token' ? 'key' : 'app';